import {observer} from "mobx-react";
import PageAncestor from "../../../core/common/page/pageAncestor";
import {MODULE, PageProps} from "../../../core/metamodel/metaConstant";
import {loc} from "../../../core/common/config/locales";
import {PROJECT_VERSION_ROOM_CATEGORIES_LIST, PROJECT_VERSION_ROOM_TYPES_LIST} from "../../gridsContants";
import gridService from "../../../core/grid/gridService";
import GridCompConnected from "../../../core/grid/component/gridCompConnected";
import mdEntityService from "../../../core/metamodel/mdEntityService";
import React from "react";

let typesGrid, categoriesGrid;

@observer
export default class ProjectVersionRoomList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.sbtool;
  static title = loc.i18n`Room types`;
  static icon = 'list';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("ProjectVersionRoomList#fetchData(%s, %s)", PROJECT_VERSION_ROOM_TYPES_LIST, PROJECT_VERSION_ROOM_CATEGORIES_LIST);

    return gridService.fetchGrids(PROJECT_VERSION_ROOM_TYPES_LIST, PROJECT_VERSION_ROOM_CATEGORIES_LIST)
      .then(gridLocationMap => {
        typesGrid = gridService.getOrCreateGrid(PROJECT_VERSION_ROOM_TYPES_LIST);
        categoriesGrid = gridService.getOrCreateGrid(PROJECT_VERSION_ROOM_CATEGORIES_LIST);
      });
  }

  render() {
    let { params, query } = this.props;


    return (
      <div>
        <GridCompConnected grid={typesGrid} entities={mdEntityService.entityMap} gridId={params.gridId} query={query} />
        <GridCompConnected grid={categoriesGrid} entities={mdEntityService.entityMap} gridId={params.gridId} query={query} />
      </div>
    );
  }


}



// WEBPACK FOOTER //
// ./src/sbtool/page/project/roomTypesList.tsx